import React, { useEffect, useState } from "react";
import styled from "styled-components";
import InputMask from "react-input-mask";
import ContractModel from "../data/models/contract";
import {
  getContractAssociatedInfo,
  getContractInfo,
  getIdContract,
  setIdCategory,
} from "../data/services/crew_service";
import {
  getCities,
  getLimitedRelationships,
  getUnidades,
} from "../data/services/form_contract";
import {
  ChoosePlanCard,
  ClearButton,
  ConfirmButton,
  DependentsButton,
  FormContainer,
  FormField,
  FormInput,
  FormRow,
  PlansDropdown,
  SearchCPFBar,
  SearchCPFContainer,
  SearchIcon,
} from "../styles/ChoosePlan";
import DialogComponent from "./Dialog";
import LimitedRelationshipModel from "../data/models/limitedRelationship";
import Dependent2 from "./DependentForm2";
import { removeMask } from "../utils/remove_mask";

const BlurWrapper = styled.div<{ isBlurred: boolean }>`
  filter: ${(props) => (props.isBlurred ? "blur(5px)" : "none")};
  width: 100%;
  height: 100%;
`;

export default function ChoosePlan() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [contractData, setContractData] = useState<any>(null);
  const [plans, setPlans] = useState<ContractModel["planos"]>([]);
  const [cpf, setCpf] = useState<string>("");
  const [tempIdContract, setTempIdContract] = useState<string>("");
  const [municipios, setMunicipios] = useState<any>([]);
  const [estados, setEstados] = useState<Set<string>>(new Set());
  const [selectedPlanName, setSelectedPlanName] = useState<string>("");
  const [unidades, setUnidades] = useState<any>([]);
  const [selectedCityName, setSelectedCityName] = useState("");
  const [relationships, setRelationships] = useState<
    LimitedRelationshipModel[]
  >([]);

  const [dependents, setDependents] = useState<
    {
      nome: string;
      telefone: string;
      cpf: string;
      email: string;
      relationship: string;
    }[]
  >([]);
  const addDependent = () => {
    setDependents([
      ...dependents,
      { nome: "", telefone: "", cpf: "", email: "", relationship: "" },
    ]);
  };

  const removeDependent = (index: number) => {
    setDependents(dependents.filter((_, i) => i !== index));
  };

  const updateDependent = (index: number, field: string, value: string) => {
    setDependents((prev) =>
      prev.map((dependent, i) =>
        i === index ? { ...dependent, [field]: value } : dependent
      )
    );
  };

  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    email: "",
    cep: "",
    rua: "",
    bairro: "",
    numero: "",
    cidade: "",
    estado: "",
    clube: "",
  });

  useEffect(() => {
    setTempIdContract(getIdContract());
    const fetchPlans = async () => {
      try {
        const idContract = getIdContract();
        const { contract } = await getContractInfo(idContract);

        if (contract) {
          setContractData(contract);
          setPlans(contract.planos || []);
        } else {
          console.error("Contrato não encontrado.");
        }
      } catch (error) {
        console.error("Erro ao buscar os dados do contrato:", error);
      }
    };

    const fetchUnidades = async () => {
      try {
        const { unidades } = await getUnidades();
        setUnidades(unidades);
      } catch (error) {
        console.error("Erro ao buscar unidades:", error);
      }
    };

    const fetchMunicipios = async () => {
      try {
        const { cities, states } = await getCities();
        setMunicipios(cities);
        setEstados(states);
        console.log(cities, "CIDADES");
        console.log(states, "ESTADOS");
      } catch (error) {
        console.error("Erro ao buscar municípios:", error);
      }
    };

    fetchPlans();
    fetchMunicipios();
    fetchUnidades();
  }, []);

  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCpf(e.target.value);
  };

  const handleClearForm = () => {
    setCpf("");
    setFormData({
      nome: "",
      telefone: "",
      email: "",
      cep: "",
      rua: "",
      bairro: "",
      numero: "",
      cidade: "",
      estado: "",
      clube: "",
    });
    setDependents([]);
    setIdCategory("");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSearchClick = async () => {
    if (!cpf) {
      alert("Por favor, insira um CPF válido.");
      return;
    }

    try {
      const { contract } = await getContractAssociatedInfo(cpf);

      if (!contract) {
        alert("Nenhum contrato associado encontrado para o CPF informado.");
        return;
      }

      if (!municipios || municipios.length === 0) {
        alert("A lista de municípios ainda não foi carregada.");
        return;
      }

      const cidadeEncontrada = municipios.find(
        (m: any) => String(m.codigo) === String(contract.idCidade)
      );

      const cidadeCodigo = cidadeEncontrada ? cidadeEncontrada.codigo : "";
      const estadoSigla = cidadeEncontrada ? cidadeEncontrada.uf : "";

      setFormData((prev) => ({
        ...prev,
        estado: estadoSigla,
      }));

      setTimeout(() => {
        setFormData((prev) => ({
          ...prev,
          nome: contract.nome || "",
          telefone: contract.telefoneEmp || "",
          email: contract.emailCob || "",
          cep: contract.cep || "",
          rua: contract.logradouro || "",
          bairro: contract.bairro || "",
          numero: contract.numero || "",
          cidade: cidadeCodigo,
          clube: contract.idClube || "",
        }));
        setSelectedCityName(cidadeEncontrada?.nomeMunicipio || "");
      }, 50);
    } catch (error) {
      console.error("Erro ao buscar contrato:", error);
      alert("Erro ao buscar contrato. Verifique o console.");
    }
  };

  const handleConfirmClick = () => {
    const requiredFields = [
      { field: "nome", label: "Nome completo" },
      { field: "telefone", label: "Telefone" },
      { field: "email", label: "E-mail" },
      { field: "cep", label: "CEP" },
      { field: "rua", label: "Rua" },
      { field: "bairro", label: "Bairro" },
      { field: "numero", label: "Número" },
      { field: "cidade", label: "Cidade" },
      { field: "estado", label: "Estado" },
    ];

    const emptyFields = requiredFields.filter(
      ({ field }) => !formData[field as keyof typeof formData]?.trim()
    );

    if (!cpf.trim()) {
      alert("O campo CPF é obrigatório.");
      return;
    }

    if (selectedPlanName == "") {
      alert("Escolha um plano para continuar");
      return;
    } else {
      if (emptyFields.length > 0) {
        const fieldNames = emptyFields.map((f) => f.label).join(", ");
        alert(
          `Preencha os seguintes campos antes de prosseguir:\n${fieldNames}`
        );
        return;
      }
    }

    for (let i = 0; i < dependents.length; i++) {
      const dep = dependents[i];

      if (
        !dep.nome?.trim() ||
        !dep.cpf?.trim() ||
        !dep.relationship ||
        !dep.email?.trim() ||
        !dep.telefone?.trim()
      ) {
        alert(`Preencha todos os campos obrigatórios do dependente ${i + 1}.`);
        return;
      }
    }

    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handlePlansDropdown = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedIdCategory = event.target.value;
    setIdCategory(selectedIdCategory);

    const selectedPlan = plans.find(
      (plano) => plano.idCategoria === selectedIdCategory
    );

    if (selectedPlan) {
      setSelectedPlanName(selectedPlan.categoria || "");
    }

    try {
      const { relationships } = await getLimitedRelationships(
        selectedIdCategory
      );

      setRelationships(relationships);
    } catch (error) {
      console.error("Erro ao buscar relacionamentos:", error);
      setRelationships([]);
    }
  };

  return (
    <>
      <div style={{ position: "relative", width: "100%" }}>
        <BlurWrapper isBlurred={isDialogOpen}>
          <ChoosePlanCard>
            <h1>Contrato: {tempIdContract}</h1>
            <h1>{contractData?.nomeFantasia}</h1>
            <ClearButton onClick={handleClearForm}>Limpar Dados</ClearButton>
            <PlansDropdown name="" onChange={handlePlansDropdown}>
              <option value="" disabled selected>
                CLIQUE AQUI E ESCOLHA O PLANO
              </option>
              {plans.map((plano) => (
                <option
                  key={plano.idContratoCategoria}
                  value={plano.idCategoria!}
                >
                  {plano.categoria} - R$ {plano.valor}
                </option>
              ))}
            </PlansDropdown>
            <FormContainer>
              <SearchCPFContainer>
                <InputMask
                  mask="99999999999"
                  value={cpf}
                  onChange={handleCpfChange}
                >
                  {(inputProps: any) => (
                    <SearchCPFBar
                      {...inputProps}
                      placeholder="CPF (Somente Números)"
                      type="text"
                    />
                  )}
                </InputMask>
                <SearchIcon size={20} onClick={handleSearchClick} />
              </SearchCPFContainer>

              <FormField>
                <FormInput
                  type="text"
                  name="nome"
                  placeholder="Nome Completo:"
                  value={formData.nome}
                  onChange={handleInputChange}
                />
              </FormField>

              <FormField>
                <InputMask
                  mask="(99) 99999-9999"
                  value={formData.telefone}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="tel"
                      name="telefone"
                      placeholder="Telefone:"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <FormInput
                  type="email"
                  name="email"
                  placeholder="E-mail:"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </FormField>

              <FormField>
                <InputMask
                  mask="99999-999"
                  value={formData.cep}
                  onChange={handleInputChange}
                >
                  {(inputProps: any) => (
                    <FormInput
                      {...inputProps}
                      type="text"
                      name="cep"
                      placeholder="CEP:"
                    />
                  )}
                </InputMask>
              </FormField>

              <FormField>
                <FormInput
                  type="text"
                  name="rua"
                  placeholder="Rua:"
                  value={formData.rua}
                  onChange={handleInputChange}
                />
              </FormField>

              <FormRow>
                <FormField>
                  <FormInput
                    type="text"
                    name="bairro"
                    placeholder="Bairro:"
                    value={formData.bairro}
                    onChange={handleInputChange}
                  />
                </FormField>
                <FormField>
                  <FormInput
                    type="text"
                    name="numero"
                    placeholder="Nº:"
                    value={formData.numero}
                    onChange={handleInputChange}
                  />
                </FormField>
              </FormRow>

              <FormRow>
                <FormField>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={(e) =>
                      setFormData({ ...formData, estado: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Escolha o estado
                    </option>
                    {Array.from(estados).map((uf) => (
                      <option key={uf} value={uf}>
                        {uf}
                      </option>
                    ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="cidade"
                    value={formData.cidade}
                    onChange={(e) => {
                      const cityCode = e.target.value;

                      const cityObj = municipios.find(
                        (m: any) => String(m.codigo) === String(cityCode)
                      );

                      setSelectedCityName(cityObj?.nomeMunicipio || "");
                      setFormData({ ...formData, cidade: cityCode });
                    }}
                  >
                    <option value="" disabled>
                      Escolha a cidade
                    </option>
                    {municipios
                      .filter(
                        (municipio: any) => municipio.uf === formData.estado
                      )
                      .map((municipio: any) => (
                        <option key={municipio.codigo} value={municipio.codigo}>
                          {municipio.nomeMunicipio}
                        </option>
                      ))}
                  </select>
                </FormField>
                <FormField>
                  <select
                    name="unidade"
                    value={formData.clube}
                    onChange={(e) =>
                      setFormData({ ...formData, clube: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Escolha a unidade
                    </option>
                    {unidades.map((u: any) => (
                      <option key={u.id_clube} value={u.id_clube}>
                        {u.razao_social}
                      </option>
                    ))}
                  </select>
                </FormField>
              </FormRow>

              {(() => {
                const name = selectedPlanName.trim().toLowerCase();

                const endsWithIndividual = name.endsWith("individual");
                const hasExtraAfterIndividual = /individual\s+\S+/i.test(name);

                if (endsWithIndividual && !hasExtraAfterIndividual) {
                  return null;
                }

                if (
                  (name.includes("individual + 1 agregado") ||
                    name.includes("individual+1agregado") ||
                    name.includes("individual+1 agregado")) &&
                  dependents.length >= 1
                ) {
                  return null;
                }
                return (
                  <DependentsButton onClick={addDependent}>
                    + DEPENDENTE
                  </DependentsButton>
                );
              })()}
              {dependents.map((dependent, index) => (
                <Dependent2
                  key={index}
                  index={index}
                  dependent={dependent}
                  onRemove={removeDependent}
                  onChange={updateDependent}
                  relationships={relationships}
                />
              ))}
            </FormContainer>
            <ConfirmButton isExpanded={true} onClick={handleConfirmClick}>
              Concluir
            </ConfirmButton>
          </ChoosePlanCard>
        </BlurWrapper>
      </div>

      <DialogComponent
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Confirme as informações abaixo"
        name={formData.nome}
        cpf={removeMask(cpf)}
        email={formData.email}
        CEP={removeMask(formData.cep)}
        address={formData.rua}
        city={selectedCityName}
        cityCode={formData.cidade}
        unidade={formData.clube}
        neighborhood={formData.bairro}
        number={formData.numero}
        phone={removeMask(formData.telefone)}
        bithday=""
        compliment=""
        state={formData.estado}
        dependents={dependents}
      />
    </>
  );
}
